import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import { IState } from '../../store';
import { closeSendSimilar, sendFormToSimilarOfferAction as sendFormAction } from '../../store/deal-rent';
import { DealRentSendSimilarModal } from './DealRentSendSimilarModal';
import { trackSafeRentSimilarFormClick } from '../../store/deal-rent/tracking';
import { ISimilarModalStateProps, ISimilarModalDispatchProps } from './typings';

export function mapStateToProps(state: IState): ISimilarModalStateProps {
  return {
    isOpen: state.dealRent.isSendSimilarModal,
    offerId: state.offerData.offer.id,
  };
}

export function mapDispatchToProps(dispatch: Dispatch<IState>): ISimilarModalDispatchProps {
  return {
    closeModal: () => {
      trackSafeRentSimilarFormClick();
      dispatch(closeSendSimilar());
    },
    sendForm: val => dispatch(sendFormAction(val)),
  };
}

export const DealRentSendSimilarModalContainer = connect(mapStateToProps, mapDispatchToProps)(DealRentSendSimilarModal);
